import React from 'react';

export const SourcesList = ({ sources }) => (
  <div className="pt-8 mt-8 border-t-2 border-brand-primary">
    <h3 className="heading-5 text-brand-primary mb-4">Fonti:</h3>
    <ul className="space-y-2 body-small text-text-secondary">
      {sources.map((source) => (
        <li key={source.url}>
          <a
            href={source.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-primary hover:underline"
          >
            {source.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);
